<template>
  <div>
    <el-card
      ><el-row class="title-biaoti">房间背景配置</el-row
      ><el-row class="search">
        <el-select
          v-model="search.valid"
          placeholder="是否有效"
          clearable=""
          filterable=""
        >
          <el-option label="无效" value="0"></el-option>
          <el-option label="有效" value="1"></el-option>
        </el-select>
        <el-button type="primary" @click="query" :loading="login">
          查询
        </el-button>
        <el-button type="success" @click="operate(1)"> 新增</el-button>
        <el-button type="warning" @click="resetSearch"> 重置</el-button></el-row
      >
      <el-row>
        <el-table
          height="65vh"
          :data="dataList"
          style="width: 100%"
          v-loading="login"
          border
        >
          <el-table-column prop="name" label="背景标题" align="center">
          </el-table-column>
          <el-table-column
            prop="iconUrl"
            label="背景图"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-image
                style="width: 150px; height: auto"
                :src="scope.row.iconUrl"
                :preview-src-list="[scope.row.iconUrl]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="showUrl"
            label="背景预览图"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-image
                style="width: 150px; height: auto"
                :src="scope.row.showUrl"
                :preview-src-list="[scope.row.showUrl]"
              ></el-image>
            </template>
          </el-table-column>
          <el-table-column
            prop="dynamicDisplayUrl"
            label="动态背景展示图"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.dynamicDisplayUrl"
                style="width: 150px; height: auto"
                :src="scope.row.dynamicDisplayUrl"
                :preview-src-list="[scope.row.dynamicDisplayUrl]"
              ></el-image>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="dynamicPreviewUrl"
            label="动态背景预览图"
            align="center"
            sortable
          >
            <template slot-scope="scope">
              <el-image
                v-if="scope.row.dynamicPreviewUrl"
                style="width: 150px; height: auto"
                :src="scope.row.dynamicPreviewUrl"
                :preview-src-list="[scope.row.dynamicPreviewUrl]"
              ></el-image>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="svipLevel" label="SVIP等级" align="center" sortable>
            <template slot-scope="scope">
              {{ scope.row.svipLevel !== null && scope.row.svipLevel !== undefined ? `SVIP${scope.row.svipLevel}` : '-' }}
            </template>
          </el-table-column>
          <el-table-column prop="valid" label="状态" align="center" sortable>
            <template slot-scope="scope"
              >{{ scope.row.valid == 1 ? '有效' : '无效' }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="operate(2, scope.row)"
                >编辑</el-button
              >
            </template>
          </el-table-column></el-table
        ></el-row
      >
      <el-row>
        <el-pagination
          :current-page.sync="pageInfo.page"
          layout="total, prev, pager, next"
          background
          @current-change="handleCurrentChange"
          :total="pageInfo.total"
          class="pagination"
          :page-size="30"
        ></el-pagination>
      </el-row>
    </el-card>
    <el-dialog
      :title="type === 1 ? '新增房间背景配置' : '编辑房间背景配置'"
      :visible.sync="dialog"
      width="50%"
      :before-close="handleClose"
    >
      <div class="item">
        <span>背景标题</span
        ><el-input type="text" v-model="form.name"></el-input>
      </div>
      <div class="item">
        <span>背景图</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="value => changfile(1, value)"
          ref="upload"
        >
          <el-image
            v-if="form.iconUrl !== ''"
            style="width: 178px; height: auto"
            :src="form.iconUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>背景预览图</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="value => changfile(2, value)"
          ref="upload"
        >
          <el-image
            v-if="form.showUrl !== ''"
            style="width: 178px; height: auto"
            :src="form.showUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>动态背景展示图</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="value => changfile(3, value)"
          ref="uploadDynamicDisplay"
        >
          <el-image
            v-if="form.dynamicDisplayUrl !== ''"
            style="width: 178px; height: auto"
            :src="form.dynamicDisplayUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>动态背景预览图</span
        ><el-upload
          class="avatar-uploader"
          action=""
          :auto-upload="false"
          :show-file-list="false"
          :on-change="value => changfile(4, value)"
          ref="uploadDynamicPreview"
        >
          <el-image
            v-if="form.dynamicPreviewUrl !== ''"
            style="width: 178px; height: auto"
            :src="form.dynamicPreviewUrl"
            fit="scale-down"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </div>
      <div class="item">
        <span>SVIP等级</span>
        <el-input-number
          v-model="form.svipLevel"
          :min="0"
          :max="10"
          placeholder="0表示0级，1-10表示SVIP1-10"
          style="width: 200px"
        ></el-input-number>
      </div>
      <div class="item">
        <span>是否有效</span>
        <el-switch
          v-model="form.valid"
          active-text="有效"
          inactive-text="无效"
          :active-value="1"
          :inactive-value="0"
        ></el-switch>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="operate(3)"
          v-loading="dwnload"
          type="primary"
          v-if="type === 1"
        >
          新 增
        </el-button>
        <el-button
          v-loading="dwnload"
          @click="operate(4)"
          type="primary"
          v-else
        >
          编 辑
        </el-button>
        <el-button @click="handleClose">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: false,
      dialog: false,
      dwnload: false,
      dataList: [],
      type: 1,
      search: {
        valid: null
      },
      pageInfo: {
        page: 1,
        total: 0
      },
      form: {
        id: '',
        name: '',
        iconUrl: '',
        showUrl: '',
        dynamicDisplayUrl: '',
        dynamicPreviewUrl: '',
        svipLevel: null,
        valid: 1
      }
    }
  },
  async created() {
    this.query()
  },
  methods: {
    async query() {
      this.login = true
      const { data: res } = await this.$axios.get(
        this.$store.getters.path.room_background_query +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        {
          params: { ...this.search, page: this.pageInfo.page }
        }
      )
      this.login = false
      if (res.code != 0) return this.$message(res.msg)
      this.dataList = res.data.data
      this.pageInfo.total = res.data.total
      this.login = false
    },
    handleCurrentChange(num) {
      this.pageInfo.page = num
      this.query()
    },
    resetSearch() {
      this.search = {
        valid: null
      }
      this.query()
    },
    async operate(type, obj) {
      this.type = type
      if (type == 1) {
        this.dialog = true
      } else if (type === 2) {
        this.dialog = true
        this.form = { ...obj }
      } else if (type === 3 || type === 4) {
        let url
        if (type === 3) {
          url =
            this.$store.getters.path.room_background_add +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
          this.form.id = ''
        } else {
          url =
            this.$store.getters.path.room_background_edit +
            '?username=' +
            this.$store.getters.username +
            '&token=' +
            this.$store.getters.token
        }

        const { data: res } = await this.$axios.get(url, { params: this.form })
        if (res.code != 0) return this.$message.error(res.msg)
        this.dialog = false
        this.query()
        this.$message.success(res.msg)
      }
    },
    async changfile(type, file) {
      this.dwnload = true
      const formdata = new FormData()
      formdata.append('file', file.raw)
      formdata.append('cover', 0)
      
      // 根据类型设置不同的目录
      let dir = 'room_background/icon/'
      if (type === 1) {
        dir = 'room_background/icon/'
      } else if (type === 2) {
        dir = 'room_background/show/'
      } else if (type === 3) {
        dir = 'room_background/dynamic_display_url/'
      } else if (type === 4) {
        dir = 'room_background/dynamic_preview_url/'
      }
      
      formdata.append('dir', dir)
      const { data: res } = await this.$axios.post(
        this.$store.getters.path.hostmgr_upload +
          '?username=' +
          this.$store.getters.username +
          '&token=' +
          this.$store.getters.token,
        formdata
      )
      this.dwnload = false
      if (res.code !== 0) {
        // 根据类型清除对应的上传组件
        if (type === 1 || type === 2) {
          this.$refs.upload.clearFiles()
        } else if (type === 3) {
          this.$refs.uploadDynamicDisplay.clearFiles()
        } else if (type === 4) {
          this.$refs.uploadDynamicPreview.clearFiles()
        }
        return this.$message.error('文件上传失败请重新选择文件上传')
      }
      if (type == 1) {
        this.form.iconUrl = res.data
      } else if (type == 2) {
        this.form.showUrl = res.data
      } else if (type == 3) {
        this.form.dynamicDisplayUrl = res.data
      } else if (type == 4) {
        this.form.dynamicPreviewUrl = res.data
      }
    },
    handleClose() {
      this.form = {
        id: '',
        name: '',
        iconUrl: '',
        showUrl: '',
        dynamicDisplayUrl: '',
        dynamicPreviewUrl: '',
        svipLevel: null,
        valid: 1
      }
      this.dialog = false
    }
  }
}
</script>
<style scoped lang="scss">
.search {
  display: flex;
  > * {
    margin: 0 5px;
  }
  .el-input {
    width: 300px;
  }
}
.cell {
  display: flex;
  > * {
    margin: 2px;
  }
}
.item {
  display: flex;
  align-items: center;
  padding: 5px 0;
  span {
    white-space: nowrap;
    padding: 0 5px;
  }
}
</style>
